module.exports = __webpack_public_path__ + "img/maintenance.1e61a3ba.svg";